<template>
  <div v-if="articles.length" class="hdp-articles-list">
    <div v-for="article in articles" :key="article.id" class="hdp-articles-item" @click="$emit('route', {name: 'ArticleView', params: {articleId: article.id}})">{{ article.title }}</div>
  </div>
</template>

<script>
export default {
  name: 'ArticlesList',

  props: {
    articles: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
  .hdp-articles-list {
    margin: -18px 0;
  }
  .hdp-articles-item {
    padding: 18px 0;
    border-bottom: 1px solid rgba(255,255,255, .2)
  }
  .hdp-articles-item:last-child {
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArticlesList.vue